/*
Ashraf 11/27/2022 2698947782 search data repository form
Ashraf 11/28/2022 2698947782 removed default values
Ashraf 11/28/2022 2698947782 add search form fields
Gummala Prakash 11/29/2022 2698947782 Fixed Field Alignments and Responsiveness.
Ashraf 12/01/2022 2698947782 removed indicator field.
Ashraf 12/01/2022 2698947782 converting window name to uppercase.
Ashraf 12/01/2022 2698947782 added window name in initial values.
Ashraf 12/01/2022 2698947782 changed placeholder for created for.
Ashraf 12/01/2022 2698947782 increased field size
Dilip 12/05/2022 2698947782 Removed unnecessary console.log statements
lalitha 12/07/2022 2698947782 added Created By field
akhila 12/08/2022  2698947782 adding session storage for search items
kavya9reddy 12/09/2022 2698947782 Added createdDate field
Suresh peddavoora 12/20/2022 2698947782 Fixed textFields UI alignments
Raghu 12/29/2022 2698947782 Field Alignment Fixes
Dilip 02/13/2023 2698947782 created by , creted for dropdown changes
suresh peddavoora 02/24/2023 2698947782 New UI changes added
suresh peddavoora 03/15/2023 2698947782 responsive fields alignment fixes
Prakash 03/16/2023 2698947782 fixed alignments issue in responsive
Prakash 06/04/2023 2698947782 fixed alignments issue in responsive
Sohel 05/26/2023 2698947782 Added Created Date Validation
Akhila 06/08/2023 2698947782 created date change to date created field and column
AKhila 06/08/2023 2698947782 re arrange the search screen with table column
Prakash 19/06/2023 2698947782 fixed alignments issue in responsive
Sohel 10/06/2023 4136387705 Changed Window Name Validation
*/
import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getBaseCategory} from '../../redux/reducers/GlobalField/AddFieldList';
import {Button, TextField, FormHelperText} from '@material-ui/core';
import {Form, Formik} from 'formik';
import ErrorBoundaryForComponents from '../../util/ErrorBoundaryForComponents';
import {ThemeContext} from '../../themes/ThemeProvider';

import {WarningSnackbar} from '../../components/CustomSnackBar';
import * as Yup from 'yup';
import UserDefinedWindows from './UserDefinedWindows';
import {
  fetchCreatedByDropDownData,
  fetchCreatedForDropDownData,
  getAllReportCreatedForData,
} from '../../redux/reducers/ReportMaster';
import {MuiPickersUtilsProvider, KeyboardDatePicker} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import GuiTextField from '../FormComponents/GuiTextField';
import {createForOptions, createdByOptions} from '../../util/CreatedByForOptions';

const SearchCustomWindow = ({
  UDWData,
  setWindowNumber,
  setIsCopyRowData,
  setEditExisting,
  setInitialValues,
  setFormData,
  changedWindowNumber,
  setChangedWindowNumber,
  setValue,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [searchData, setSearchData] = useState();
  const [submit, setSubmit] = useState(false);
  const {baseCategoryData} = useSelector(({addFieldList}) => addFieldList);
  // const [customError, setCustomError] = useState(false);
  const customError = false;
  const filteredCategory = baseCategoryData?.filter((item) => item?.categoryCode !== 'AR');
  const {createdForData, createdByData} = useSelector(
    ({reportMaster}) => reportMaster,
  );
  // form field validation(2700799562)
  const schema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  // reset data and fetch Base Catagory dropdown data(2700799562)
  useEffect(() => {
    dispatch(getBaseCategory());
  }, []);
  const SearchSessionCustomWindows = JSON.parse(sessionStorage.getItem('CustomWindows'));
  // form initialvalues(2700799562)
  const initialValues = {
    windowName: '',
    windowDescription: '',
    category: {},
    createdFor: '',
    indicator: '',
    header: '',
    createdBy: '',
    createdDate: null,
  };

  // set search Data(2700799562)
  const handleSubmit = (values) => {
    setSearchData(values);
    setSubmit(true);
    sessionStorage.setItem('CustomWindows', JSON.stringify(values));
  };
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedForDropDownData('customwindow'));
    dispatch(fetchCreatedByDropDownData('customwindow'));
  }, [dispatch]);
  return (
    // Removed Card styles for text fields (2700799562)
    <>
      <div>
        <Formik
          onSubmit={handleSubmit}
          initialValues={SearchSessionCustomWindows ? SearchSessionCustomWindows : initialValues}
          enableReinitialize
          validationSchema={schema}
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              setFieldValue,
              touched,
              errors,
              resetForm,
            } = props;

            return (
              // Changes text field variant from outlined to standard (2700799562)
              <div>
                <Form autoComplete="off">
                  <ErrorBoundaryForComponents>
                    <div className="form-row align-items-center standard-field-textfields new-standard-textfields">
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-2 col-xl-2 form-group autocomplete-field">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                            popper: classes.popper,
                          }}
                          name="category"
                          id="category"
                          size="small"
                          value={values?.category}
                          options={filteredCategory}
                          getOptionDisabled={(option) => option?.categoryCode === ''}
                          getOptionLabel={(option) => {
                            return option && option?.categoryName ?
                              option?.categoryCode === null ?
                                option?.categoryName :
                                option?.categoryCode + ' - ' + option?.categoryName :
                              '';
                          }}
                          onChange={(e, value) => {
                            setFieldValue('category', value);
                          }}
                          placeholder="Select Category"
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                margin="dense"
                                name="category"
                                label="Category"
                                placeholder="Select Category"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <TextField
                          margin="dense"
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          placeholder={`Enter Window Name`}
                          label="Window Name"
                          name="windowName"
                          value={values?.header}
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue(
                              'header',
                              e?.target?.value,
                            );
                          }}
                          onBlur={handleBlur}
                          fullWidth
                          touched={touched.windowName}
                          error={Boolean(touched.windowName && errors.windowName)}
                        />
                        <FormHelperText>
                          {touched.windowName && errors.windowName && errors.windowName}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-xs-6 col-md-4 col-lg-4 col-xl-4 form-group">
                        <TextField
                          margin="dense"
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          placeholder="Enter Window Description"
                          label="Window Description"
                          name="windowDescription"
                          value={values.windowDescription}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          fullWidth
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdFor"
                          id="createdFor"
                          size="small"
                          value={values.createdFor}
                          options={createdForData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createForOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdFor', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                variant="outlined"
                                margin="dense"
                                label="Created For"
                                placeholder="Select Created For"
                                className={` ${classes.labelName}`}
                              />
                              <FormHelperText variant="outlined">
                                {touched.createdFor && errors.createdFor}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2  form-group">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="createdBy"
                          id="createdBy"
                          size="small"
                          value={values.createdBy}
                          options={createdByData}
                          getOptionLabel={(option) => {
                            return option && option?.userLoginName ? option?.userLoginName : '';
                          }}
                          renderOption={(option) => {
                            return createdByOptions(option);
                          }}
                          onChange={(e, value) => {
                            setFieldValue('createdBy', value);
                          }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                {...params}
                                className={` ${classes.labelName}`}
                                variant="outlined"
                                margin="dense"
                                label="Created By"
                                placeholder="Select Created By"
                              />
                            </div>
                          )}
                        />
                      </div>
                      <div className="col-sm-6 col-md-4 col-lg-2 col-xl-2 form-group start-enddate">
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={` ${classes.labelName}`}
                            format="MM/dd/yyyy"
                            placeholder="MM/DD/YYYY"
                            fullWidth
                            value={values.createdDate}
                            name="createdDate"
                            onBlur={handleBlur}
                            inputVariant="outlined"
                            helperText=""
                            label="Date Created"
                            onChange={(val) => {
                              setFieldValue('createdDate', val);
                            }}
                            autoOk
                            margin="dense"
                            touched={touched?.createdDate}
                            error={Boolean(touched?.createdDate && errors?.createdDate)}
                          />
                        </MuiPickersUtilsProvider>
                        <FormHelperText variant="outlined">
                          {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                        </FormHelperText>
                      </div>
                      <div className="col-md-12 col-lg-3 col-xl-2 form-group">
                        <div className="d-flex align-items-center justify-content-xl-start justify-content-md-center">
                          <Button
                            variant="outlined"
                            className={`mr-1 reset-btn`}
                            onClick={() => {
                              setSearchData(initialValues);
                              setSubmit(true);
                              resetForm(initialValues);
                              sessionStorage.removeItem('CustomWindows');
                            }}
                          >
                            Reset
                          </Button>
                          <Button type="submit" variant="outlined" className={`ml-1 search-btn`}>
                            Search
                          </Button>
                        </div>
                      </div>
                    </div>
                  </ErrorBoundaryForComponents>
                </Form>
              </div>
            );
          }}
        </Formik>
        <UserDefinedWindows
          UDWData={UDWData}
          setValue={setValue}
          changedWindowNumber={changedWindowNumber}
          setChangedWindowNumber={setChangedWindowNumber}
          setFormData={setFormData}
          setInitialValues={setInitialValues}
          setEditExisting={setEditExisting}
          setWindowNumber={setWindowNumber}
          setIsCopyRowData={setIsCopyRowData}
          setSubmit={setSubmit}
          submit={submit}
          searchData={searchData}
        />
        {customError && <WarningSnackbar errorMsg={'This Field List is not being used anywhere'} />}
      </div>
    </>
  );
};

export default SearchCustomWindow;
